import React from "react";
import { Checkbox, Divider, Grid } from "@mui/material";

const ProductRow = ({ product, selected, onSelect, actions, hideCheckbox = false }) => {
    product.displaySize =  [product.rankName, product.productClassName, product.packingName].filter(Boolean).join(" ")
    return (
        <>
            <Grid container alignItems="center" sx={{ py: 1 }}>
                <Grid item xs={3}>
                    {product.productName}
                </Grid>
                <Grid item xs={2.5}>
                    {product.originName}
                </Grid>
                {/*<Grid item xs={1}>*/}
                {/*    {product.supplyTypeName}*/}
                {/*</Grid>*/}
                <Grid item xs={2}>
                    {product.displaySize}
                </Grid>
                <Grid item xs={1.5}>
                    {product.weight || ""}{product.weightUnitName}
                </Grid>
                <Grid item xs={1}>
                    {product.supplyUnitName}
                </Grid>
                <Grid item xs={1.5}>
                    {actions}
                </Grid>
                {!hideCheckbox && (
                    <Grid item xs={0.5}>
                        <Checkbox checked={selected} onChange={onSelect} />
                    </Grid>
                )}
            </Grid>
            <Divider variant="fullWidth" sx={{ opacity: 0.3 }} />
        </>
    );
};

export default ProductRow;
